/** @format */

export const getBtnProps = (code) => {
	switch (code) {
		case 'add':
			return { icon: 'Plus' };
		case 'delete':
			return { icon: 'Delete' };
		default:
			return {};
	}
};
